// extracted by mini-css-extract-plugin
export default {"headerText":"SingleAssetSelfTest_headerText__kMj+p","headerActions":"SingleAssetSelfTest_headerActions__JQ-xq"};